import Section from "@/features/website/components/Section";
import PartnersReel from "@/features/website/landing/PartnersReel";
// import LaptopAndPhone from '@/features/website/landing/assets/laptop-and-phone-patient-watch.png';
import DesktopMobile from "@/features/website/landing/assets/desktop-mobile-patient-watch.png";
import { useAuth } from "@/utils/auth";
import { ArrowBigDown, ArrowBigUp } from "lucide-react";

import { landingComponents as lc } from ".";
import useNavigateOnboardingOrProfile from "../../onboarding/hooks/useNavigateOnboardingOrProfile";
import GetInTouch from "../components/GetInTouch";
import { ComplianceReel } from "./ComplianceReel";
import { WordAnimation } from "./components/WordAnimation";
import { generalFAQs } from "./content/generalFaqs";
// TODO - Testimonial
const Landing = () => {
	const auth = useAuth();
	const navigateNext = useNavigateOnboardingOrProfile();
	return (
		<div>
			<Section className="pt-16 pb-8">
				<lc.Hero
					// title={<PowerToThePatients />}
					title={
						<span className="font-light dark:text-slate-100 transition-all duration-1000">
							Remote Follow-Ups to
							<br />
							Save Time for <WordAnimation />
						</span>
					}
					description="Make smarter treatment decisions, gather audit data and enjoy happier patients with real-time remote monitoring."
					primaryText={auth.id ? "Sign In" : "Sign Up / Sign In"}
					primaryOnClick={() => navigateNext()}
					image={DesktopMobile}
					disclaimer={
						<div className="flex flex-row gap-2 mt-8 p-2 text-slate-800 lg:text-md dark:text-slate-200">
							<div className="flex flex-row items-center gap-1">
								<ArrowBigUp />
								Improve Care
							</div>
							<div className="flex flex-row items-center gap-1">
								<ArrowBigDown />
								Save Time
							</div>
						</div>
					}
					hideSecondary={!auth.isAuthenticated}
				/>
			</Section>

			<lc.Problem />

			{/* <Section color="indigo">
                <div className="flex flex-col gap-y-4 mx-auto px-4 font-medium text-slate-800 text-lg lg:text-xl text-center">
                    <p>
                        <i>"Patient Watch has saved our department countless unnecessary appointments."</i>
                    </p>
                </div>
            </Section> */}

			<lc.DiaryDemo />
			<lc.Actions />
			<lc.Report />

			<lc.Why />

			<Section
				className="mt-10 mb-20"
				title={
					<span className="font-semibold text-slate-800 dark:text-slate-200 text-2xl">
						Proud to Work with
					</span>
				}
			>
				<PartnersReel />
				<span className="mx-auto font-semibold text-slate-800 dark:text-slate-200 text-xl">
					and be Acredited by
				</span>
				<ComplianceReel />
			</Section>

			<Section>
				<GetInTouch />
			</Section>

			<Section>
				<lc.FaqBlock FAQs={generalFAQs} />
			</Section>
		</div>
	);
};

export default Landing;
